import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: '[app-composer-nav]',
  templateUrl: './composer-nav.component.html',
  styleUrls: ['./composer-nav.component.scss']
})
export class ComposerNavComponent implements OnInit {
  @Input('survey_id') survey_id;
  constructor() {}
  ngOnInit() {}
}
